import React, { useMemo, useState } from 'react';
import { onboardingTimezones } from './onboardingWorkspace';

export default function OnboardingTimezoneSelect({ value, onChange, disabled, error }: {
  value: string; onChange: (value: string) => void; disabled: boolean; error?: string;
}) {
  const [search, setSearch] = useState('');
  const zones = useMemo(() => onboardingTimezones(value), [value]);
  const filtered = zones.filter((zone) => zone === value || zone.replace(/_/g, ' ').toLowerCase().includes(search.trim().toLowerCase()));
  return <div className="min-w-0">
    <label className="block text-sm font-medium" htmlFor="onboarding-timezone">Timezone</label>
    <input type="search" aria-label="Search timezones" className="input-field mt-1 mb-2" value={search} disabled={disabled} onChange={(event) => setSearch(event.target.value)} />
    <select id="onboarding-timezone" className="input-field w-full" value={zones.includes(value) ? value : ''} disabled={disabled} aria-invalid={Boolean(error)} aria-describedby={error ? 'timezone-error' : undefined} onChange={(event) => onChange(event.target.value)}>
      <option value="" disabled>Choose timezone</option>
      {filtered.map((zone) => <option key={zone} value={zone}>{zone.replace(/_/g, ' ')}</option>)}
    </select>
    {filtered.length === (zones.includes(value) ? 1 : 0) && search && <p role="status" className="text-xs mt-1">No other matching timezones.</p>}
    {error && <p id="timezone-error" className="text-sm text-red-700 mt-1">{error}</p>}
  </div>;
}
